/* global axios */
import ApiClient from '../ApiClient';

class CaptainAiActionProposals extends ApiClient {
  constructor() {
    super('captain/ai_action_proposals', { accountScoped: true });
  }

  get({ page = 1, status, assistantId, conversationId, toolId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        status,
        assistant_id: assistantId,
        conversation_id: conversationId,
        tool_id: toolId,
      },
    });
  }

  approve(id) {
    return axios.post(`${this.url}/${id}/approve`);
  }

  reject(id, reason) {
    return axios.post(`${this.url}/${id}/reject`, { reason });
  }
}

export default new CaptainAiActionProposals();
